module.exports = __webpack_public_path__ + "img/btn-save-bm.e1dd71eb.png";